/* eslint-disable consistent-return */
import { useEffect, useState } from 'react';
import cn from 'classnames';

import Button from '@/components/Button';
import Banner from '@/components/nav/banner';
import MainNav from '@/components/nav/main-nav';
import {
  useNavigationState,
  useNavigationDispatch,
} from '@/contexts/navigation';
import { useWindowWidth } from '@/hooks/useWindowWidth';

import styles from './nav.module.css';
import StickyNav from './sticky-nav';

export default function Header() {
  const [menuIsFixed, setIsFixed] = useState(true);
  const { windowWidth } = useWindowWidth();
  const { isOpen } = useNavigationState();
  const { closeNav } = useNavigationDispatch();

  useEffect(() => {
    if (windowWidth && windowWidth >= 1024) closeNav();
  }, [windowWidth]);

  function handleIsFixed(isFixed: boolean) {
    setIsFixed(isFixed);
  }

  return (
    <>
      <div
        className={cn(
          `z-modal w-full text-current`,
          isOpen ? `fixed inset-0 bg-white !text-haiti` : `relative`,
          styles.nav,
          menuIsFixed ? styles.navWithBanner : styles.navWithoutBanner,
        )}
      >
        <Banner className={menuIsFixed ? `block` : `hidden`} />

        <StickyNav handleIsFixed={handleIsFixed} windowWidth={windowWidth} />

        {/* Mobile */}
        {windowWidth && windowWidth < 1024 && (
          <>
            <MainNav isDesktop={false} />

            {isOpen && (
              <div className="border-t border-catskill-white lg:border-t-0 p-2 flex flex-col bg-white w-full z-50">
                <Button
                  href="https://app.graphcms.com/signup"
                  size="large"
                  colour="faded-cornflower"
                  onClick={closeNav}
                >
                  Get started
                </Button>

                <Button
                  href="/contact"
                  size="large"
                  colour="purple"
                  className="mt-4"
                >
                  Contact sales
                </Button>
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
}
